import React, { useState,useEffect } from 'react';
import axios from 'axios';
import { showToast,ToastMessage } from '../../Shared/ToastMessage';
import { baseUrl } from '../../../api/common';

const ReviewAdd = ({fetchReviewStatusData,addPopupStatus, handleAddPopup, eventType, updateData}) => {

  const [updateId, setUpdateId] = useState("");

  const [formValues, setFormValues] = useState({
    review_status_name:""
  });

  const [errors, setErrors] = useState({
    reviewStatusName:""
  });

  const handleInputChange = (field, value) => {
    setFormValues({ ...formValues, [field]: value });
  };

  const validate = () => {
    const newErrors = {
     reviewStatusName:""
    };  
    if (!formValues.review_status_name.trim()) {
      newErrors.reviewStatusName = 'Review status cannot be empty';
    }  
    setErrors(newErrors);
    return Object.values(newErrors).every((error) => error === '');
  };  

  const clearInputValues = () => {
    setErrors({
     reviewStatusName:""
    });
    setFormValues({
     review_status_name:""
    });
    handleAddPopup(false);
  };  

  const addUpdateReviewStatus = async () => {
    if (validate()) {
      console.log('Post Data:', formValues);   
      try {
        const requestData = {
          ...formValues,
          ...(eventType === "Update" && { id: updateId }),
        };
        console.log("Update requestData Data:", requestData);
        const response = await axios.post(
          `${baseUrl}/api/add_review_status`,
          requestData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: localStorage.getItem('access_token'),
            },
          }
        );
        if (response.data.status) {
          showToast(response.data.message, 'success');
          fetchReviewStatusData();
          clearInputValues();
        } else {
          showToast(response.data.message, 'error');
        }
      } catch (error) {
        console.error("Error during submission:", error);
        showToast("A network error occurred, or the server is temporarily busy. Please try again later.", "error");
      }
    }
  };

  useEffect(() => {
    if (eventType === "Update" && updateData) {
      console.log("Update Data:", updateData);
      setUpdateId(updateData.id);
      setFormValues({
        review_status_name: updateData.review_status_name || ''
      });
    }else{
      setErrors({
        reviewStatusName:""
       });
       setFormValues({
        review_status_name:""
       });
    }
  }, [eventType, updateData, addPopupStatus]);

  return (
    <>
    <ToastMessage/>    
    {addPopupStatus && (
      <div
        className={`extraspace_search_div search_div${addPopupStatus ? ' open' : ''}`}
      >
        <div className="card member_master_sidebar_scrool">
          <div className="member_edit_pop_flex mb-3 text-end">
            <h3>{eventType} Review Status</h3>
            <div className="input-group-append">
              <span
                onClick={() => clearInputValues()}
                className="search_toggle btn btn-danger"
              >
                <i className="fa fa-times" />
              </span>
            </div>
          </div>
          <div className="table-responsive">
            <div className="body application_body_side">
              <div>             
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group pos_relative">
                        <label>Review Status</label>
                        <input
                          type="text"
                          className={`form-control ${errors.reviewStatusName?"red_border":''}`}
                          value={formValues.review_status_name}
                          onChange={(e) => handleInputChange('review_status_name', e.target.value)} 
                          required
                        />
                        {errors && (                          
                            <p className="text-danger pos_abos">{errors.reviewStatusName}</p>                          
                        )}
                      </div>
                    </div>
                    <div className="col-md-12 member_button_flex">
                      <button onClick={() => addUpdateReviewStatus()} className="btn btn-outline-info">
                      {eventType}
                      </button>
                      <a
                        onClick={() => clearInputValues()}
                        className="btn btn-outline-danger"
                      >
                        Close
                      </a>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )}
    </>
  );
};

export default ReviewAdd;
